import $ from 'jquery';

$(document).ready(function () {
  if (!document.getElementById('all-queries')) {
    return;
  }
  dataAccessor.getAllGraphs().then(function (graphs) {
    // Removed redundant variable declaration
    for (var i = 0; i < graphs.length; i++) {
      var graph = graphs[i];
      $('#all-queries').append("<li class='list-group-item'>" + graph + '</li>');
    }
  }).catch(function (err) {
    console.error('admin getAllGraphs failed', err);
  });
});

/* SAML Provider Management - Commented out until ready to implement
document.addEventListener('user-ready', function(e, userData) {
    if (!userData || !userData.id) {
        window.location.href = '/login';
        return;
    }

    // SAML Provider Management
    const samlProviderDialog = document.getElementById('saml-provider-dialog');
    const samlProviderForm = document.getElementById('saml-provider-form');
    const addSamlProviderBtn = document.getElementById('add-saml-provider-btn');
    const samlProviderCancel = document.getElementById('saml-provider-cancel');
    const samlProviderSave = document.getElementById('saml-provider-save');
    const samlDialogError = document.getElementById('saml-dialog-error');
    const samlProvidersList = document.getElementById('saml-providers-list');

    if (!samlProviderDialog) {
        console.error('SAML provider dialog not found. Admin page may not be properly initialized.');
        return;
    }

    // Initialize the dialog
    if (!samlProviderDialog.showModal) {
        dialogPolyfill.registerDialog(samlProviderDialog);
    }

    // Load SAML providers
    function loadSamlProviders() {
        if (!userData || !userData.secret) return;

        fetch(`/saml/providers?secret=${userData.secret}`)
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error ${response.status}`);
                }
                return response.json();
            })
            .then(providers => {
                renderSamlProviders(providers);
            })
            .catch(error => {
                console.error('Error loading SAML providers:', error);
            });
    }

    // Render SAML providers in the table
    function renderSamlProviders(providers) {
        samlProvidersList.innerHTML = '';

        if (!providers || providers.length === 0) {
            const row = document.createElement('tr');
            row.innerHTML = `
                <td class="mdl-data-table__cell--non-numeric" colspan="4">
                    No SAML providers configured yet. Click "Add SAML Provider" to create one.
                </td>
            `;
            samlProvidersList.appendChild(row);
            return;
        }

        providers.forEach(provider => {
            const row = document.createElement('tr');
            row.innerHTML = `
                <td class="mdl-data-table__cell--non-numeric">${provider.name}</td>
                <td class="mdl-data-table__cell--non-numeric">${provider.entity_id}</td>
                <td class="mdl-data-table__cell--non-numeric">
                    <span class="status-badge ${provider.is_active ? 'active' : 'inactive'}">
                        ${provider.is_active ? 'Active' : 'Inactive'}
                    </span>
                </td>
                <td class="mdl-data-table__cell--non-numeric">
                    <button class="mdl-button mdl-js-button mdl-button--icon edit-provider" data-id="${provider.id}">
                        <i class="material-icons">edit</i>
                    </button>
                    <button class="mdl-button mdl-js-button mdl-button--icon delete-provider" data-id="${provider.id}">
                        <i class="material-icons">delete</i>
                    </button>
                </td>
            `;
            samlProvidersList.appendChild(row);

            // Add event listeners to the buttons
            row.querySelector('.edit-provider').addEventListener('click', function() {
                editSamlProvider(provider);
            });

            row.querySelector('.delete-provider').addEventListener('click', function() {
                deleteSamlProvider(provider.id);
            });
        });
    }

    // Open the dialog for adding a new SAML provider
    function addSamlProvider() {
        // Reset the form
        samlProviderForm.reset();
        document.getElementById('saml-provider-id').value = '';
        samlDialogError.style.visibility = 'hidden';

        // Open the dialog
        samlProviderDialog.showModal();
    }

    // Open the dialog for editing an existing SAML provider
    function editSamlProvider(provider) {
        // Fill the form with provider data
        document.getElementById('saml-provider-id').value = provider.id;
        document.getElementById('saml-provider-name').value = provider.name;
        document.getElementById('saml-provider-description').value = provider.description || '';
        document.getElementById('saml-provider-entity-id').value = provider.entity_id;
        document.getElementById('saml-provider-sso-url').value = provider.sso_url;
        document.getElementById('saml-provider-slo-url').value = provider.slo_url || '';
        document.getElementById('saml-provider-x509cert').value = provider.x509_cert;
        document.getElementById('saml-provider-firebase-id').value = provider.firebase_provider_id;
        document.getElementById('saml-provider-button-text').value = provider.button_text || '';
        document.getElementById('saml-provider-button-color').value = provider.button_color || '';
        document.getElementById('saml-provider-icon-url').value = provider.icon_url || '';
        document.getElementById('saml-provider-allowed-domains').value =
            Array.isArray(provider.allowed_domains) ? provider.allowed_domains.join(', ') : '';
        document.getElementById('saml-provider-is-active').checked = provider.is_active;

        // Update MDL textfields to ensure they're properly displayed
        componentHandler.upgradeAllRegistered();

        // Open the dialog
        samlProviderDialog.showModal();
    }

    // Save SAML provider (create or update)
    function saveSamlProvider() {
        const providerId = document.getElementById('saml-provider-id').value;
        const allowedDomainsStr = document.getElementById('saml-provider-allowed-domains').value;
        const allowedDomains = allowedDomainsStr
            ? allowedDomainsStr.split(',').map(domain => domain.trim()).filter(Boolean)
            : [];

        const providerData = {
            secret: userData.secret,
            id: providerId || undefined,
            name: document.getElementById('saml-provider-name').value,
            description: document.getElementById('saml-provider-description').value,
            entity_id: document.getElementById('saml-provider-entity-id').value,
            sso_url: document.getElementById('saml-provider-sso-url').value,
            slo_url: document.getElementById('saml-provider-slo-url').value,
            x509_cert: document.getElementById('saml-provider-x509cert').value,
            firebase_provider_id: document.getElementById('saml-provider-firebase-id').value,
            button_text: document.getElementById('saml-provider-button-text').value,
            button_color: document.getElementById('saml-provider-button-color').value,
            icon_url: document.getElementById('saml-provider-icon-url').value,
            allowed_domains: allowedDomains,
            is_active: document.getElementById('saml-provider-is-active').checked
        };

        fetch('/saml/providers', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(providerData)
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    throw new Error(data.error || `HTTP error ${response.status}`);
                });
            }
            return response.json();
        })
        .then(data => {
            // Close the dialog
            samlProviderDialog.close();

            // Reload the providers list
            loadSamlProviders();
        })
        .catch(error => {
            console.error('Error saving SAML provider:', error);
            samlDialogError.textContent = error.message;
            samlDialogError.style.visibility = 'visible';
        });
    }

    // Delete a SAML provider
    function deleteSamlProvider(providerId) {
        if (!confirm('Are you sure you want to delete this SAML provider?')) {
            return;
        }

        fetch(`/saml/providers/${providerId}?secret=${userData.secret}`, {
            method: 'DELETE'
        })
        .then(response => {
            if (!response.ok) {
                return response.json().then(data => {
                    throw new Error(data.error || `HTTP error ${response.status}`);
                });
            }
            return response.json();
        })
        .then(data => {
            // Reload the providers list
            loadSamlProviders();
        })
        .catch(error => {
            console.error('Error deleting SAML provider:', error);
            alert(`Error deleting SAML provider: ${error.message}`);
        });
    }

    // Event listeners
    if (addSamlProviderBtn) {
        addSamlProviderBtn.addEventListener('click', addSamlProvider);
    }

    if (samlProviderCancel) {
        samlProviderCancel.addEventListener('click', function() {
            samlProviderDialog.close();
        });
    }

    if (samlProviderSave) {
        samlProviderSave.addEventListener('click', saveSamlProvider);
    }

    // Load SAML providers when the page loads
    loadSamlProviders();
});

// Add some CSS for the SAML management section
document.addEventListener('DOMContentLoaded', function() {
    const style = document.createElement('style');
    style.textContent = `
        .saml-management-section {
            margin-top: 30px;
            margin-bottom: 30px;
        }

        .status-badge {
            padding: 4px 8px;
            border-radius: 4px;
            font-size: 12px;
            font-weight: 500;
        }

        .status-badge.active {
            background-color: #4CAF50;
            color: white;
        }

        .status-badge.inactive {
            background-color: #F44336;
            color: white;
        }
    `;
    document.head.appendChild(style);
});
*/
